import { type Memberships } from './collections/memberships'
import { type Teams } from './collections/teams'
import { teamsLedByEmployee } from './teamsLedByEmployee'

export const userIsTeamLead = (teams: Teams, memberships: Memberships, employeeId: number) => {
  return teamsLedByEmployee(teams, memberships, employeeId).length > 0
}
